import React, { useEffect, useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import axios from "axios";
import { REACT_APP_API_URL } from "../../../../../../env";

const EditRoomModal = ({ isOpen, onClose, roomId, onUpdated }) => {
  console.log("EditRoomModal Props:", { isOpen, roomId, onClose, onUpdated });
  const [roomType, setRoomType] = useState("");
  const [description, setDescription] = useState("");
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (isOpen && roomId) {
      axios.get(`${REACT_APP_API_URL}api/room-config/${roomId}`)
        .then(res => {
          setRoomType(res.data.RoomType || "");
          setDescription(res.data.Description || "");
        })
        .catch(err => console.error("Failed to load room:", err));
    }
  }, [isOpen, roomId]);

  const handleUpdate = async () => {
    try {
      setSaving(true);
      const payload = {           
        P_INTROOMCONFIGID: roomId,
        P_VCHROOMTYPE: roomType,
        P_VCHDESCRIPTION: description,
        P_INTCREATEDBY: 1
      };
      const res = await axios.put(`${REACT_APP_API_URL}api/room-config/edit-room`, payload);
      if (res.data?.success) {
        onUpdated?.();
        onClose();
      } else {
        alert(res.data?.message || "Update failed");
      }
    } catch (error) {
      console.error("Error updating room:", error);
      alert("Failed to update room details.");
    } finally {
      setSaving(false);
    }
  };

  return (
    <Modal show={isOpen} onHide={onClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Edit Room</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Form>
          <Form.Group className="mb-3">
            <Form.Label>Room Type</Form.Label>
            <Form.Control
              type="text"
              value={roomType}
              onChange={(e) => setRoomType(e.target.value)}
              placeholder="Enter room type"
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Description</Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              placeholder="Enter description"
            />
          </Form.Group>
        </Form>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={onClose} disabled={saving}>
          Cancel
        </Button>
        <Button variant="secondary" onClick={handleUpdate} disabled={saving}>
          {saving ? "Saving..." : "Update Changes"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default EditRoomModal;